import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import { MessageContentState } from "../types";

export const BannerContentMessage: React.FC<MessageContentState> = ({
    leftMessageProps,
    linkProps,
    rightMessage,
    buttonProps
}) => {
    const { t } = useTranslation();
    return (
        <div className={styles["banner-content"]}>
            <div
                className={`${styles["message"]} ${
                    linkProps?.end ? styles["reverse"] : ""
                }`}
            >
                {t(leftMessageProps.key, leftMessageProps.params)} <br></br>
                {leftMessageProps.subheader && (
                    <span className={styles["subheader"]}>
                        {t(leftMessageProps.subheader)}
                    </span>
                )}
                {linkProps && (
                    <small>
                        {linkProps && (
                            <Link
                                to={linkProps.href}
                                onClick={linkProps.onClick}
                            >
                                {t(linkProps.text)}
                            </Link>
                        )}
                        {rightMessage ? t(rightMessage) : ""}
                    </small>
                )}
            </div>
            {buttonProps && (
                <button
                    onClick={buttonProps.onClick}
                    className={`btn ${buttonProps.type} ${buttonProps.className}`}
                >
                    {buttonProps.label}
                </button>
            )}
        </div>
    );
};
